import {Storage} from "modules/utils";

export const SecretPageKey = "secret";

export const IS_SHOW_SECRET_PAGE = JSON.parse(
	Storage.GET(SecretPageKey) || process.env.REACT_APP_IS_SHOW_SECRET_PAGE || "false"
) as boolean;
